
import { Icon } from "@iconify/react";
import "../css/userdash.css"
import "../css/accountlevel.css"
import useStore from "../store/zustandstore";
import { useEffect, useRef,useState } from "react";
import AccountLevel from "../components/accoutlevel";
import Maindash from "../components/userdash/usermaindash";
import Userdashmenu from "../components/userdash/userdashsidemenu";
import { Helmet } from "react-helmet";
import PaymentMethod from "../components/userdash/paymentmethod";
import Userprofile from "../components/userdash/userprofile";
import usefbStore from "../store/firebasestore";
import Reverification from "../components/userdash/reverification";
import { useNavigate } from "react-router-dom";
import AccountStatus from "../components/userdash/userprofilesettings";
import { getAuth,signOut } from "firebase/auth";
import paypal from "../media/paypal.png"
import { useSocketStore } from "../store/socketstore";
import visa from "../media/visa2.webp"
import eth from "../media/ethereum.png"
import Swal from "sweetalert2";
   import {
  collection,
  getDocs,
  doc,
  updateDoc
} from "firebase/firestore";
import {db} from "../firebase/firebase"
import "../css/transactiondetails.css"
function Userdash(){

  const isUserDashboardActive= useStore((s)=>s.isUserDashboardActive)
  const isUserAccountSettings= useStore((s)=>s.isUserAccountSettings)
  const isUserPaymentMethods= useStore((s)=>s.isUserPaymentMethods)
  const isUserProfileActive= useStore((s)=>s.isUserProfileActive)
  const currentUserUid = usefbStore((s)=>s.userID)
  const userName = usefbStore((s)=>s.userName)
  const slctdTransID = usefbStore((s)=>s.slctdTransID)
  const authStatus = usefbStore((s)=>s.authStatus)
  const showUserDashNav = useStore((s)=>s.showUserDashNav)
  const isUserDashNavActive = useStore((s)=>s.isUserDashNavActive)
  const [greetings, setGreetings] = useState("")
  const [trxnView, setTrxnView] = useState({})
  const forceLogout = useSocketStore((s)=>s.forceLogout)
  const navigate = useNavigate()
  const accountBalance = usefbStore((s)=>s.accountBalance)
    const transactions = usefbStore((s)=>s.transactions);

    const [trxnArray,setTrxnArray]= useState([])

  const setTrxnDet = useStore((s)=>s.setTrxnDet)
  const trxnDetail = useStore((s)=>s.trxnDetail)
  const allAccountLevels = useStore((s)=>s.allAccountLevels)
  const setAllAccountLevels = useStore((s)=>s.setAllAccountLevels)

    const isReverified = usefbStore((s)=>s.isReverified)
        const setShowReVe = useStore((s)=>s.setShowReVe)
        const isShowReVe = useStore((s)=>s.isShowReVe)


 const formatTransactionDate = (dateValue) => {
  const date = dateValue?.toDate
    ? dateValue.toDate()
    : new Date(dateValue);

  const weekday = date.toLocaleDateString("en-US", {
    weekday: "short",
  });

  const day = String(date.getDate()).padStart(2, "0");

  const month = date.toLocaleDateString("en-US", {
    month: "short",
  });

  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${weekday}, ${day} ${month} ${year} ${hours}:${minutes}`;
};
  function getGreetings(){
    const hours = new Date().getHours()
    if(hours < 12) return "Good morning,"
    if(hours < 18) return "Good afternoon,"
    
    return "Good evening,"
  }

  useEffect(()=>{
    if(isReverified === false){
       setShowReVe(true)
    }
  },[isReverified])


useEffect(() => {
  if (!transactions || !Array.isArray(transactions)) {
    return;
  }

  setTrxnArray(transactions);

  const selectedTransaction = transactions.find(
    (trxn) => trxn.id === slctdTransID
  );

  setTrxnView(selectedTransaction || {});
}, [transactions, slctdTransID]);


  const getStatusStyle = (status) => {
  switch(status) {
    case "completed":
      return { color: " rgb(0, 238, 0)", background: "rgba(0, 128, 0, 0.26)" };
    case "rejected":
    case "failed":
      return { color: "red", background: "#ff00001b" };
    default:
      return { color: " rgb(0, 238, 0)", background: "#22acfc17" };
  }
};

  useEffect(()=>{
    setGreetings(getGreetings())
    const interval = setInterval(() => {
    setGreetings(getGreetings())
    }, 60 * 1000);
    return ()=> clearInterval(interval)

  },[])  
 useEffect(() => {
  if (forceLogout) {
    Swal.fire({
      title: "Session Ended",
      text: "Your account has been signed in on another device. For security reasons, this session has been closed.",
      icon: "warning",
      timer: 4000,              // ⏱ auto close
      timerProgressBar: true,
      showConfirmButton: false, // no blocking
      allowOutsideClick: false,
      allowEscapeKey: false,
      didClose: () => {
 const auth = getAuth()
                    signOut(auth).then(()=>{
                        navigate("/auth")
                    }).catch(()=>{
                        Swal.fire("Error", "An error occured", "error")
                    })      }
    });
  }
}, [forceLogout]);



 
    useEffect(()=>{

        if(authStatus==="authenticated"){
        useSocketStore.getState().setUid(currentUserUid)
        useSocketStore.getState().connect()
      
        }else if(authStatus=="unauthenticated"){
          navigate("/auth")
    }
    else{
            
        }
 
    },[authStatus])
    
 const cncelAccLevels =()=>{
  setAllAccountLevels(false)
 }




    return(
    <>
    <div className={`floatingisShowReVe  ${isShowReVe ? "floatingisShowReVeActive" : ""}`}>
      <Reverification />
    </div>
    <div className={`floatingAccountLevel ${allAccountLevels ? "floatingAccountLevelActive" : ""}`} onClick={()=>cncelAccLevels()}>
      <AccountLevel />
    </div>
<div className={`txnDetaillsPop ${trxnDetail ? "txnDetaillsPopActive" : ""}`}>
  <div className="tdWrap tdWrapActive">
    <div className="tdWrapPlacer">

      <div className="tdSecPlacer">

        <div className="tdTopSec">

          <div className="tdTopIcon">
            <img
              src={
                trxnView.withdrawMethod === "PayPal"
                  ? paypal
                  : trxnView.withdrawMethod === "Bank Transfer"
                  ? visa
                  : eth
              }
              alt="payIcon"
            />
          </div>

          <div className="tdPayWrap">

            <div className="tdPaymentMethod">
              <span>
                {trxnView.withdrawMethod}
              </span>
            </div>

            <div className="tdPaymentDate">
            <span>
  {formatTransactionDate(trxnView.createdAt)}
</span>
            </div>

          </div>
        </div>


        <div className="tdMidSec">

          <div className="tdMidSecMin">
            <p>Amount</p>

            <span>
              ${trxnView.amountUSD}
            </span>
          </div>


          <div className="tdMidSecSec">

            <div className="tmssCont">

              <div className="tmssColmn">

                <div className="tmsColumnicon">
                  <Icon
                    className="faIcon"
                    icon="basil:user-outline"
                  />
                </div>

                <div>
                  <p>Recipient</p>

                  <span>
                    {userName}
                  </span>
                </div>

              </div>


              <div className="tmssColmn">

                <div className="tmsColumnicon">
                  <Icon
                    className="faIcon"
                    icon="ep:coin"
                  />
                </div>

                <div>

                  <p>Transaction ID</p>

                 <span>
  {trxnArray?.find(
    (trxn) => trxn.id === slctdTransID
  )?.id?.split("_").pop()
    ? `WD_${trxnArray
        ?.find((trxn) => trxn.id === slctdTransID)
        ?.id?.split("_")
        .pop()}`
    : "N/A"}
</span>

                </div>

              </div>


              <div
  className="tmsContStatus"
  style={getStatusStyle(
    trxnArray?.find(
      (trxn) => trxn.id === slctdTransID
    )?.status
  )}
>
 <p>
  {trxnArray
    ?.find((trxn) => trxn.id === slctdTransID)
    ?.status?.replace(/^./, (letter) => letter.toUpperCase())}
</p>
</div>
            </div>

          </div>

        </div>


        <div className="tdBtmSec">

          <div className="tdBtmClmn">
            <p>Action</p>
            <span>Earnings withdrawal</span>
          </div>

          <div className="tdBtmClmn">
            <p>Notes</p>
            <span>Withdrawal payout processed by Solara</span>
          </div>

          <div className="tdBtmClmn">
            <p>Fees</p>
            <span className="tdBtmNumber">0.05%</span>
          </div>

        </div>

      </div>


      <div
        className="tdButtonCancel"
        onClick={() => setTrxnDet(false)}
      >
        <button>Done</button>
      </div>

    </div>
  </div>
</div>
     <Helmet>
        <title>Dashboard </title>
       <meta name="description" content="Manage your AI tasks, track earnings, monitor performance metrics, and access real-time analytics from your centralized dashboard. Complete tasks, withdraw earnings, and level up your AI workflow productivity." />
      </Helmet>
           <div className="userDashWrap">
        <div className={`userDashNavWrap ${isUserDashNavActive ? "userDashNavWrapActive" : ""}`}  >
            <Userdashmenu/>
        </div>
        <div className="userWholeDash">
            <div className="userWholeDashCont">
      <div className="userDashminiNav">
                <span>{greetings}</span>
                <div className="userDashminiNavIcons">
                    <div className="udnnavIcon" onClick={()=>showUserDashNav()}>
                        <Icon className="faIcon" icon="solar:menu-dots-bold"/>
                    </div>
                </div>
            </div>
            <div className="user-dashDrawerWrap">
                 <div className={`mainDashCont ${isUserDashboardActive ? "mainDashCont-Active" : ""}`}>
                    <Maindash/>
                 </div>
                 <div className={`mainDashCont ${isUserProfileActive ? "mainDashCont-Active" : ""}`}>
                    <Userprofile/>
                 </div>
                 <div className={`mainDashCont ${isUserAccountSettings ? "mainDashCont-Active" : ""}`}>
                    <AccountStatus/>
                 </div>
                 <div className={`mainDashCont ${isUserPaymentMethods ? "mainDashCont-Active" : ""}`}>
                    <PaymentMethod/>
                 </div>
            </div>
            </div>
        </div>
      </div>
    
    </>
 
    )
}

export default Userdash;